<script setup>
import { cn } from '@/lib/utils'

const props = defineProps({
  class: { type: String, default: '' },
})
</script>

<template>
  <div :class="cn('rounded-xl border border-gray-200 bg-white text-gray-900 shadow-sm', props.class)">
    <slot />
  </div>
</template>
